const isMobile = () => {
    var mobileValue = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return mobileValue;
}
module.exports = isMobile


// WEBPACK FOOTER //
// ./src/api/isMobile.js